import * as types from '../actions/actionTypes';
import initalState from './initialState';

function getUpdatedRunsForPickupFromRun(state, update) {
  let {runId, response} = update;
  let items = [...state.items.map(run => {
    let runReturn = {...run};
    if(runReturn.id == runId){
      runReturn = response;
    }
    return runReturn;
  })];
  return {items: items, loaded: state.loaded};
}

export default function driverRunsReducer(state = initalState.driverRuns, action){
  switch(action.type) {
    case types.LOAD_DRIVER_RUNS_SUCCESS:
      return {...action.driverRuns};
    case types.RUN_LOCATION_CHECKIN_SUCCESS:
      return getUpdatedRunsForPickupFromRun(state, action.checkIn);
    case types.RUN_LOCATION_TANK_PICKUP_SUCCESS:
      return getUpdatedRunsForPickupFromRun(state, action.update);
    case types.RUN_LOCATION_ADDNOTE_SUCCESS:
      return getUpdatedRunsForPickupFromRun(state, action.update);
    default:
      return state;
  }
}
